// Do not modify this file by hand!
// Re-generate this file by running lit-localize
import { html } from "lit";
import { str } from "@lit/localize";
/* eslint-disable no-irregular-whitespace */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const templates = {
    h0fca6d6cbb0506c0: html `Inteligencia de mercado`,
    h229e7d06093c2f3f: html `ESG y diversidad`,
    h4b6568de605796be: html `Juntas directivas y gobernanza`,
    h4e84df3b11ed9b4f: html `Ayuda y Soporte`,
    h722c4148bfbe6706: html `Educación y certificaciones`,
    h85f4df4fdcb8beed: html `Riesgo y estrategia`,
    hb6b70f369f25a7ac: html `Cumplimiento y ética`,
    hc639dc8eaab7815d: html `Asuntos y reportes`,
    hcd22a6d6c40d8786: html `Auditoría y estudios analíticos`,
    "link-home": `Inicio`,
    "nav-section-home": `Inicio`,
    s032cd9f1245d3645: `Espacio`,
    s08e6d298452e8f68: `Auditoría`,
    s0910fa68dccfcaa6: `Data Market Intelligence`,
    s0a860146c6f28d97: `Abrir cuadro de diálogo de métodos abreviados del teclado`,
    s0bae1af85a28bd4c: `Diligent Institute`,
    s0ccb779911d414a3: `Inventario de activos`,
    s14ba513bc8896c24: `Robots`,
    s1534ff9f453525e1: `Seleccionar la primera celda`,
    s175d37c8eb04d73e: `Descargas`,
    s1967ea0b8a2b6015: `Ejecutar la celda seleccionada`,
    s199f5853f4e718f7: `Proyectos`,
    s24761a0cc8d9c0aa: `Organización`,
    s299dc244af6aadff: `Customer Admin Boards`,
    s2aa747e75ad1b409: `Third-Party Manager`,
    s2b63dc08d32ccb09: `Desplazarse hacia arriba`,
    s2c2b04f2561a1d4b: `Analytics`,
    s2cfcd4e06c146db9: `Abrir cuadro de diálogo de selector de organización`,
    s2e109263b73c12d5: `Licencias`,
    s34d94212c9758944: `Estrategia`,
    s353873ecbaa3efe9: `Flecha izquierda`,
    s3736464cf8d6fa08: `Soporte`,
    s392dc2954562a82b: `Editor de texto`,
    s39cccc90e6fe1d7f: `Gestor de asuntos`,
    s3ab6763097d7412f: `Equity Invest`,
    s3d5b54e4d176209c: `Última diapositiva`,
    s3f809b62bcc2a44c: `Control de la misión`,
    s45efff328e4d0a4d: `Buscar organizaciones`,
    s460bf77c46d93bb4: `Cerrar cuadro de diálogo de métodos abreviados del teclado`,
    s469437ae00d48e37: `Expandir la fila actual`,
    s47de2481b149190a: `Entidades`,
    s4802e47fe2e95134: `Opción`,
    s480d27b7a8b69ce5: `Desplazarse a la izquierda`,
    s49ca4bf0e63593da: `Cerrar diálogos`,
    s4b10acae683d2978: `Pantalla completa`,
    s4b81aa9512692c4d: `Contraer navegación lateral`,
    s523eb9043213ff0d: `Itálico`,
    s56410a6c80d5215c: `Mover celda hacia abajo`,
    s58622fa7922ed03b: `Botón del menú de la Ayuda`,
    s586d6bd2eca2da93: `Usuarios`,
    s5a41c3a63f1c18af: `Configuración de perfil`,
    s5b56a21c08c842c4: `Primera diapositiva`,
    s5c1ecf88259b79f9: `Presentación`,
    s5cad0782f12d34b2: `Equity`,
    s5d9182f471cf98d1: `Mapas de cumplimiento`,
    s5d929ff1619ac0c9: `Buscar`,
    s5db46d120dcba694: `Evaluaciones`,
    s5e27738a2e8eb763: `Iniciar sesión`,
    s5e8250fb85d64c23: `Cerrar`,
    s5febcd9b311c16fe: `Desplazarse a la derecha`,
    s60565faf8db3a5cb: `Ejecute esta celda y todas las anteriores`,
    s62bc518b503d1c76: `Seleccionar la celda de abajo`,
    s63b6edf663b6a3c5: `Agregar una celda debajo`,
    s6d5cb7af3fa87c78: `Rastreador de tareas`,
    s6db55a42bcb74cfc: `Rastreador de asuntos`,
    s6fb3409caa74b0a4: `Ctrl`,
    s70113bbc33303a81: `Menú de la Ayuda`,
    s7417792bbe720149: `Rehacer`,
    s74cb3d66f6a668e1: `Documentación`,
    s7695095bb106d505: `Accuvio`,
    s7a4f059aaa029719: `Connect`,
    s7cfe12cd14df9950: `Cerrar sesión`,
    s7db511600050e797: `Ejecute esta celda y todas las siguientes`,
    s7deaf226ff8b192c: `Instaladores`,
    s7e388025be643d0d: `Intro`,
    s7eb1e34fc5ece4cd: `Menú del perfil`,
    s884bcdca26998a48: `Reportes`,
    s89365ba6fa5cdb97: `Detener la ejecución`,
    s89ba33f94f92f3cc: `Campañas de identificación`,
    s8f4be9f086eb530f: `Deshacer`,
    s9021935bcdd703b9: `Abrir un panel lateral`,
    s9373ade6d85b4388: `Contraer la fila actual`,
    s947f21967d65c480: `Marketplace`,
    s9ab2385df7adbce0: `Resaltar una fila`,
    s9dd12575273ac110: `Desplazarse hacia abajo`,
    s9df9510d60035af3: `Abrir menú del perfil`,
    s9f26843287bb592d: `Grupos`,
    s9fda4232f5e1876a: `Obtenga ayuda`,
    sa05b93d8764f88ed: `Gestor de riesgos`,
    sa103c8e0c776e11c: `Solicitar métodos abreviados del teclado`,
    sa153c163bc11460d: `Centro de actividades`,
    sa35ed9234d3d66ce: `No se encontraron organizaciones`,
    sa4bb7742cdfc214e: `Director Boards`,
    sa872b0bfe51f2d40: `Estructura de la organización`,
    saed6432f1517ea10: `Gestor de activos`,
    saf7a5eef69e5bb59: `Flecha hacia arriba`,
    sb061ff5a347a296e: `Perfil`,
    sb206d700d26b14ff: `Subrayar`,
    sb21cca7db5de38f3: `Storyboards`,
    sb284cd019b430d1e: `No hay métodos abreviados del teclado específicos de la aplicación.`,
    sb32c8490570a8831: `Panorama de diapositivas`,
    sb4484b8d878dffff: `Logs de actividad`,
    sb752d83c4e4619bc: str `Cambiar a ${0}`,
    sb888017adf7992b9: `Academia de Diligent`,
    sbd63362a31200ab4: `Ir a Launchpad`,
    sbda32dab0c54ffdd: `Siguiente diapositiva`,
    sbf84c104b8212e06: `Seleccionar la celda de arriba`,
    sc203eef710f83583: `Esta aplicación no admite el uso de métodos abreviados del teclado específicos.`,
    sc2873891e8c3be68: `Editor de scripts de Robots`,
    sc835e30bc3bdd2fd: `Mover celda hacia arriba`,
    sc8aa5792985e2ba3: `Configuración de la plataforma`,
    sca1a826088564455: `Resultados`,
    sca442b5dc0fd394c: `Flecha hacia abajo`,
    scdd4399eeeacd8f4: `Cambiar de organización`,
    sd0864ea6cb6ef22e: `Community`,
    sd0b6082239185272: `Seleccionar todo`,
    sd1182e4e6a0ada64: `Policy Manager`,
    sd1b2ae9109b29cf0: `Navegación lateral`,
    sd1c09a62f063a73b: `Gestor de tareas`,
    sd514ab1c93237dae: `Planes de aseguramiento`,
    sd76505ffae553332: `Portal de investigación`,
    sd81eecf773db25fc: `Ejecutar todas las celdas en secuencia`,
    sd8f923198e0c5c6a: `Fin`,
    sd90a1e198e1ac71e: `Esc`,
    sd9fb2375a5c991c5: `No admitimos métodos abreviados específicos para esta aplicación, pero si tiene alguna sugerencia, háganosla saber.`,
    sdc599e1d5c823e75: `Seleccionar la última celda`,
    sdcc5f064d591aefd: `Diapositiva anterior`,
    se2faf168207b0a48: `Marcos`,
    se3b4c857f91f80d7: `Métodos abreviados del teclado`,
    se65e4e6f3696e997: `Capacitación`,
    se93a3eaf86201ae7: `Mayús.`,
    sed2d45e3f811c81d: `Básico`,
    see0ef54044d25a50: `Book Admin Boards`,
    sf0d3b85da03d1e55: `Eliminar la celda seleccionada`,
    sf2d615b20d62225a: `Programador`,
    sf41a0c89409353dc: `Flecha derecha`,
    sf5597bb9f2103d2a: `Activaciones`,
    sf7c0eba7c822e3d6: `En negrita`,
    sf95b10c03a2d5872: `Abrir navegación lateral`,
    sf993c3199fefcb9c: `Alt`,
    sf9b1c0661a02d9f9: `Configuración`,
    sfc6b9ce43d2c798c: `Planillas de horas`,
    sfe3d666017079dce: `BoardEffect`,
    "shortcuts-home": `Inicio`,
};
